import { Navigate, useRoutes } from 'react-router-dom';
// layouts
// config
// import { PATH_AFTER_LOGIN } from 'src/config-global';
//
import { mainRoutes } from './main';
import { authRoutes } from './auth';
import { authDemoRoutes } from './auth-demo';
import { dashboardRoutes } from './dashboard';
import { superadmindashboardRoutes } from './superadmin-dashboard';
import { admindashboardRoutes } from './admin-dashboard';

import { componentsRoutes } from './components';
import { GuestGuard } from 'src/auth/guard';
import LoginView from 'src/sections/auth/jwt/login-view';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // SET INDEX PAGE WITH SKIP HOME PAGE
    // {
    //   path: '/',
    //   element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    // },

    // ----------------------------------------------------------------------

    // SET INDEX PAGE WITH HOME PAGE
    {
      path: '/',
      element: (
        <GuestGuard>
          {/* <AuthClassicLayout> */}
            <LoginView />
          {/* </AuthClassicLayout> */}
        </GuestGuard>
      ),
    },

    // Auth routes
    ...authRoutes,
    ...authDemoRoutes,
    //  Dashboard routes
    ...dashboardRoutes,

    //super-admin dashboard
    ...superadmindashboardRoutes,

    //user-dashboard
    ...admindashboardRoutes,

    // Main routes
    ...mainRoutes,

    // Components routes
    ...componentsRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
